<template>
    <div class="bg-[#ffffff]">
        <div>
            <main class="mx-auto max-w-7xl pr-4 sm:pr-6 lg:pr-4 ml-4 sm:ml-6 lg:ml-4">
                <section aria-labelledby="heading" class="pt-4">
                    <div class="">
                        <div class="justify-center flex bg-slate-700 hover:bg-slate-500"
                            @click="stateStore.returnAllSelected(selectedFilters)"
                            style="cursor:pointer; border-radius: .4rem;">
                            <div class="py-1 font-medium text-white ">
                                Reset Filters
                            </div>

                        </div>
                        <!-- Filters -->
                        <form class="lg:block pt-3">
                            <Disclosure as="div" v-for="section in  filters " :key="section.id"
                                class="border-b border-gray-200 py-4" v-slot="{ open }">
                                <h3 class="-my-3 flow-root">
                                    <DisclosureButton
                                        class="flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500">
                                        <span class="font-bold text-gray-900 text-base">{{ section.name }}</span>
                                        <span class="ml-6 flex items-center">
                                            <PlusIcon v-if="!open" class="h-5 w-5" aria-hidden="true" />
                                            <MinusIcon v-else class="h-5 w-5" aria-hidden="true" />
                                        </span>
                                    </DisclosureButton>
                                </h3>
                                <DisclosurePanel class="pt-1">
                                    <div class="space-y-4">
                                        <Accordion class="pt-2" :multiple="true" expandIcon="pi pi-plus"
                                            collapseIcon="pi pi-minus" style="flex-direction: row-reverse !important;">
                                            <AccordionTab v-for="(options, key ) in   section.options  " :key="key">
                                                <template #header>
                                                    <span class="flex align-items-center gap-2 w-full">
                                                        <span class="font-semibold white-space-nowrap">
                                                            {{ options.label }}</span>
                                                    </span>
                                                </template>
                                                <AutoComplete v-if="options.type == 'dropdown'" class="ml-8"
                                                    v-model="selectedFilters[section.id][options.value].selected"
                                                    multiple :optionLabel=options.id :suggestions="filteredValues"
                                                    @complete="search(options.value, options.id, $event)" 
                                                    @item-select="selectedFilters[section.id][options.value].selected = [...new Set(selectedFilters[section.id][options.value].selected)]" />
                                                <InputNumber v-if="options.type == 'input'" :inputId="options.id"
                                                    class="border-solid border-2 border-gray-100 rounded-sm ml-8"
                                                    :useGrouping="false" v-model="tempinput" allowEmpty="false"
                                                    v-on:keypress="setInput(selectedFilters[section.id][options.value], section.options[key].id, tempinput)"
                                                    @focus="tempinput = null" variant="filled" />

                                                <div v-if="options.type == 'checkbox'">
                                                    <div v-for=" option  of  options.optionsList " :key="option.value"
                                                        class="flex align-items-center ml-8"
                                                        style="align-items: center;">

                                                        <Checkbox
                                                            v-model="selectedFilters[section.id][options.value].selected"
                                                            :inputId="option" name="category"
                                                            :value="turnedToJson(section.options[key].id, option.value)" />
                                                        <!-- {{ (section.options[key].id) + ":" + (option.value) }} -->
                                                        <!-- {{ option }} -->
                                                        <label :for="option.value" class="ml-2">
                                                            {{ option.name }}
                                                        </label>
                                                    </div>
                                                </div>

                                                <div v-if="options.type == 'multiselect'">
                                                    <MultiSelect
                                                        class="border-solid border-2 border-gray-100 rounded-sm ml-8"
                                                        style="width:12rem"
                                                        v-model="selectedFilters[section.id][options.value].selected"
                                                        :options="options.optionsList" :optionLabel="options.id"
                                                        :value="turnedToJson(section.options[key].id, value)"
                                                        placeholder="Select option" :maxSelectedLabels="3" />
                                                </div>

                                            </AccordionTab>
                                        </Accordion>
                                    </div>
                                </DisclosurePanel>
                            </Disclosure>
                        </form>
                    </div>
                </section>
            </main>
        </div>
    </div>
</template>


<script setup>
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from '@headlessui/vue'
import MultiSelect from 'primevue/multiselect'
import { MinusIcon, PlusIcon } from '@heroicons/vue/20/solid'
import { computed, ref, reactive, defineEmits, defineProps, onMounted } from 'vue';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import AutoComplete from 'primevue/autocomplete';
import Badge from 'primevue/badge';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import { querystate } from "../store/tableQuery/index"
import { useApiStore } from "../store/api/api"

const stateStore = querystate();
const api = useApiStore();
const props = defineProps(['sideBarState', 'batters', 'bowlers', 'venues'])
const state = reactive({ props });

let selectedValues = ref([]);
let filteredValues = ref([]);
let originalValues;
let tempinput = ref(null);
let teams = ref()

onMounted(async () => {

    await api.fetchTeamList().then((value) => {
        teams.value = value;
    })
})

function setInput(arr, id, value) {
    if (id != undefined && value != undefined) {
        arr.selected.push(turnedToJson(id, value))
    }
    tempinput.value = null;
}
function turnedToJson(key, value) {
    return JSON.parse(`{ "${key}": "${value}"}`);
}

function search(type, id, event) {
    originalValues = ref(
        {
            batters: ref({ options: props.batters }),
            bowlers: ref({ options: props.bowlers }),
            venues: ref({ options: props.venues }),
            team: ref({ options: teams })
        }
    )
    setTimeout(() => {
        if (!event.query.trim().length) {
            filteredValues.value = [...originalValues.value[type].options];
        } else {
            filteredValues.value = originalValues.value[type].options.filter((originalValues) => {
                return originalValues[id].toLowerCase().startsWith(event.query.toLowerCase());
            });
        }
    }, 250);
}
const selectedFilters = computed(() => {
    return stateStore.getFilters;
})

const filters = [
    {
        id: 'common',
        name: 'Common',
        options: [
            { 'value': 'batters', label: 'Batter', type: "dropdown", id: 'striker.display_name' },
            { 'value': 'bowlers', label: 'Bowler', type: "dropdown", id: 'bowler.display_name' },
            { 'value': 'venues', label: 'Venue', type: "dropdown", id: 'venues.stadium' },
            // { 'value': 'year', label: 'Year', type: "dropdown", id: 'striker.display_name' },
            // { 'value': 'playResult', label: 'Play Result', type: "dropdown", id: 'striker.display_name' },
            // { 'value': 'limit', label: 'Limit', type: "input" },
        ],
    },
    {
        id: 'organisation',
        name: 'Organisation',
        options: [
            {
                value: 'series', label: 'Series', type: "checkbox", id: 'matches.match_type',
                optionsList: [
                    { value: "2020 Int", name: "2020 International" },
                    { value: "2020", name: "2020" },
                    { value: "Odi", name: "ODI" },
                    { value: "BigBash", name: "Big Bash" },
                    { value: "Test", name: "Test" },
                ]
            },
            {
                value: 'league', label: 'League', type: "checkbox", id: 'matches.series',
                optionsList: [
                    { value: "Ashes  21/22", name: "Ashes" },
                    { value: "BBL 22/23", name: "BBL '22" },
                    { value: "BBL 23/24", name: "BBL '23" },
                    { value: "International 22/23", name: "International '22" },
                    { value: "International 23/24", name: "International '23" },
                    { value: "MLC 2023", name: "MLC" },
                    { value: "New Zealand vs Australia", name: "New Zealand vs Australia" },
                    { value: "New Zealand vs England", name: "New Zealand vs England" },
                ]
            },
        ],
    },
    {
        id: 'location',
        name: 'Location',
        options: [
            // {
            //         value: 'hemisphere', label: 'Hemisphere', type: "checkbox",
            //         optionsList: [
            //             { value: "north", name: "North" },
            //             { value: "south", name: "South" }
            //         ]
            //     },
            {
                value: 'country', label: 'Country', type: "checkbox", id: "matches.country",
                optionsList: [
                    { value: "Australia", name: "Australia" },
                    { value: "New Zealand", name: "New Zealand" },
                    { value: "United States", name: "USA" }
                ]
            },
            { 'value': 'venues', label: 'Venue', type: "dropdown", id: 'venues.stadium' },
            // {
            //     value: 'pitch', label: 'Pitch', type: "checkbox",
            //     optionsList: [
            //         { value: "dropin", name: "Drop In" },
            //         { value: "block", name: "Block" }
            //     ]
            // },
            // {
            //     value: 'pitchType', label: 'Pitch Type', type: "checkbox",
            //     optionsList: [
            //         { value: "kakanui", name: "Kakanui" },
            //         { value: "patu", name: "Patumahoe" }
            //     ]
            // },
            // {
            //     value: 'pitchCondition', label: 'Pitch Condition', type: "checkbox",
            //     optionsList: [
            //         { value: "green", name: "Green" },
            //         { value: "grassy", name: "Grassy" },
            //         { value: "cracked", name: "Cracked" },
            //         { value: "dry", name: "Dry" }
            //     ]
            // },
            // {
            //     value: 'boundary', label: 'Boundary', type: "checkbox",
            //     optionsList: [
            //         { value: "UnderStraight", name: "Under 60m straight" },
            //         { value: "OverStraight", name: "Over 60m straight" },
            //         { value: "UnderSquare", name: "Under 60m square" },
            //         { value: "OverSquare", name: "Over 60m square" }
            //     ]
            // },
        ],
    },
    {
        id: 'matchSetup',
        name: 'Match Setup',
        options: [
            // {
            //     value: 'setting', label: 'Setting', type: "checkbox",
            //     optionsList: [
            //         { value: "home", name: "Home" },
            //         { value: "away", name: "Away" },
            //         { value: "neutral", name: "Neutral" }
            //     ]
            // },
            {
                value: 'timeOfDay', label: 'Time Of Day', type: "checkbox", id: "matches.day_nighter",
                optionsList: [
                    { value: "Day", name: "Day" },
                    { value: "Day / Night", name: "Day/Night" },
                    { value: "Night", name: "Night" }
                ]
            },
            // { value: 'month', label: 'Month', type: "dropdown" },
        ],
    },
    {
        id: 'matchDetails',
        name: 'Match Details',
        options: [
            // { value: 'gameNumber', label: 'Game Number', type: "dropdown" },
            // { value: 'innings', label: 'Innings', type: "dropdown" },
            // { value: 'day', label: 'Day', type: "dropdown" },
            // {
            //     value: 'sessions', label: 'Sessions (Tests)', type: "checkbox",
            //     optionsList: [
            //         { value: "1", name: "1" },
            //         { value: "2", name: "2" },
            //         { value: "3", name: "3" },
            //     ]
            // },
            // { value: 'stateOfGame', label: 'State Of Game', type: "dropdown" },
            // { value: 'overs', label: 'Overs', type: "dropdown" },
            // {
            //     value: 'matchResult', label: 'Result', type: "checkbox",
            //     optionsList: [
            //         { value: "win", name: "Win" },
            //         { value: "loss", name: "Loss" },
            //         { value: "draw", name: "Draw" },
            //         { value: "tie", name: "Tie" }
            //     ]
            // },
            // {
            //     value: 'leadership', label: 'Leadership', type: "checkbox",
            //     optionsList: [
            //         { value: "undercoach", name: "Under Coach" },
            //         { value: "undercaptain", name: "Under Captain" },
            //         { value: "acaptain", name: "As Captain" },
            //         { value: "nacaptain", name: "Not As Captain" }
            //     ]
            // },
            { value: 'match_id', label: 'Match ID', type: "input", id: "matches.match_id" },
        ],
    },
    // {
    //     id: 'player',
    //     name: 'Player',
    //     options: [
    //         // {
    //         //     value: 'primaryRole', label: 'Primary Role', type: "checkbox",
    //         //     optionsList: [
    //         //         { value: "batter", name: "Batter" },
    //         //         { value: "bowler", name: "Bowler" },
    //         //         { value: "wicketkeeper", name: "Wicket Keeper" }
    //         //     ]
    //         // },
    //         // { value: 'age', label: 'Age', type: "input" },
    //         { value: 'birthPlace', label: 'Birthplace', type: "dropdown" },
    //     ],
    // },
    {
        id: 'batter',
        name: 'Batter',
        options: [
            { 'value': 'Playerid', label: 'Player ID', type: "input", id: 'striker.player_id' },
            { 'value': 'batters', label: 'Name', type: "dropdown", id: 'striker.display_name' },
            {
                'value': 'BatHand', label: 'Bat Hand', type: "checkbox", id: 'striker.bat_hand',
                optionsList: [
                    { value: "L", name: "L" },
                    { value: "R", name: "R" },
                ]
            },
            {
                'value': 'BowlStyle', label: 'Bowl Style', type: "multiselect", id: 'striker.bowl_style',
                optionsList: [
                    { 'striker.bowl_style': "LB", },
                    { 'striker.bowl_style': "LBG" },
                    { 'striker.bowl_style': "LF" },
                    { 'striker.bowl_style': "LFM" },
                    { 'striker.bowl_style': "LM" },
                    { 'striker.bowl_style': "LMF" },
                    { 'striker.bowl_style': "OB" },
                    { 'striker.bowl_style': "RF" },
                    { 'striker.bowl_style': "RFM" },
                    { 'striker.bowl_style': "RM" },
                    { 'striker.bowl_style': "RMF" },
                    { 'striker.bowl_style': "SLA" },
                    { 'striker.bowl_style': "SLC" },
                ]
            },
            { 'value': 'team', label: 'Team', type: "dropdown", id: 'striker.team' },
            {
                'value': 'HomeAway', label: 'Home/Away', type: "checkbox", id: 'striker.home_away',
                optionsList: [
                    { value: "Home", name: "Home" },
                    { value: "Away", name: "Away" },
                ]
            },
            {
                'value': 'Country', label: 'Country', type: "multiselect", id: 'striker.country',
                optionsList: [
                    { 'striker.country': "Australia" },
                    { 'striker.country': "India" },
                    { 'striker.country': "Jamaica" },
                    { 'striker.country': "New Zealand" },
                    { 'striker.country': "Pakistan" },
                    { 'striker.country': "South Africa" },
                    { 'striker.country': "Sri Lanka" },
                    { 'striker.country': "United Kingdom" },
                    { 'striker.country': "United States" },
                    { 'striker.country': "Zimbabwe" },
                ]
            },
        ],
    },
    {
        id: 'bowler',
        name: 'Bowler',
        options: [
            { 'value': 'Playerid', label: 'Player ID', type: "input", id: 'bowler.player_id' },
            { 'value': 'bowlers', label: 'Name', type: "dropdown", id: 'bowler.display_name' },
            {
                'value': 'BatHand', label: 'Bat Hand', type: "checkbox", id: 'bowler.bat_hand',
                optionsList: [
                    { value: "L", name: "L" },
                    { value: "R", name: "R" },
                ]
            },
            {
                'value': 'BowlStyle', label: 'Bowl Style', type: "multiselect", id: 'bowler.bowl_style',
                optionsList: [
                    { 'bowler.bowl_style': "LB", },
                    { 'bowler.bowl_style': "LBG" },
                    { 'bowler.bowl_style': "LF" },
                    { 'bowler.bowl_style': "LFM" },
                    { 'bowler.bowl_style': "LM" },
                    { 'bowler.bowl_style': "LMF" },
                    { 'bowler.bowl_style': "OB" },
                    { 'bowler.bowl_style': "RF" },
                    { 'bowler.bowl_style': "RFM" },
                    { 'bowler.bowl_style': "RM" },
                    { 'bowler.bowl_style': "RMF" },
                    { 'bowler.bowl_style': "SLA" },
                    { 'bowler.bowl_style': "SLC" },
                ]
            },
            { 'value': 'team', label: 'Team', type: "dropdown", id: 'bowler.team' },
            {
                'value': 'HomeAway', label: 'Home/Away', type: "checkbox", id: 'bowler.home_away',
                optionsList: [
                    { value: "Home", name: "Home" },
                    { value: "Away", name: "Away" },
                ]
            },
            {
                'value': 'Country', label: 'Country', type: "multiselect", id: 'bowler.country',
                optionsList: [
                    { 'bowler.country': "Australia" },
                    { 'bowler.country': "India" },
                    { 'bowler.country': "Jamaica" },
                    { 'bowler.country': "New Zealand" },
                    { 'bowler.country': "Pakistan" },
                    { 'bowler.country': "South Africa" },
                    { 'bowler.country': "Sri Lanka" },
                    { 'bowler.country': "United Kingdom" },
                    { 'bowler.country': "United States" },
                    { 'bowler.country': "Zimbabwe" },
                ]
            },

            // { value: 'bowlHandedness', label: 'Handedness', type: "dropdown" },
            // { value: 'bowlingPosition', label: 'Bowling Position', type: "dropdown" },
            // { value: 'bowlingType', label: 'Bowling Type', type: "dropdown" },
            // { value: 'paceType', label: 'Pace Type', type: "dropdown" },
            // { value: 'spinType', label: 'Spin Type', type: "dropdown" },
            // { value: 'wicketsTaken', label: 'Wickets Taken', type: "dropdown" },
            // { value: 'runsConceded', label: 'Runs Conceded', type: "dropdown" },
            // { value: 'oversBowled', label: 'Overs Bowled', type: "dropdown" },
        ],
    },
    // {
    //     id: 'fielder',
    //     name: 'Fielder',
    //     options: [
    //         { value: 'nameFielder', label: 'Name', type: "dropdown" },
    //         { value: 'Type', label: 'Type', type: "dropdown" },
    //         { value: 'position', label: 'Position', type: "dropdown" },
    //         { value: 'wicketInvolvement', label: 'Wicket Involvement', type: "dropdown" },
    //         { value: 'error', label: 'Error', type: "dropdown" }
    //     ],
    // },
    {
        id: 'play',
        name: 'Play',
        options: [
            { value: 'Inn', label: 'Innings', type: "input", id: "plays.innings" },
            { value: 'Over', label: 'Over', type: "input", id: "plays.over" },
            { value: 'Delivery', label: 'Delivery', type: "input", id: "plays.delivery" },
            { value: 'Ball', label: 'Ball', type: "input", id: "plays.ball" },
            // { value: 'timeCode', label: 'Time Code', type: "dropdown" },
            {
                value: 'BowlEnd', label: 'Bowl End', type: "checkbox", id: "plays.bowl_end",
                optionsList: [
                    { value: "0", name: "North" },
                    { value: "1", name: "South" },
                ]
            }
            // { value: 'WicketFell', label: 'Wicket Fell', type: "dropdown" },
            // { value: 'BreakAfterBall', label: 'Break After Ball', type: "dropdown" },

            // { value: 'shotIntention', label: 'Shot Intention', type: "dropdown" },
            // { value: 'shotSelection', label: 'Shot Selection', type: "dropdown" },
            // { value: 'shotResult', label: 'Shot Result', type: "dropdown" },
            // { value: 'shotDirection', label: 'Shot Direction', type: "dropdown" },
            // { value: 'missStumps', label: 'Hit/Miss Stumps', type: "dropdown" }
        ],
    },
    // {
    //     id: 'tracking',
    //     name: 'Tracking',
    //     options: [
    //         { value: 'releaseLine', label: 'Release Line', type: "dropdown" },
    //         { value: 'releaseHeight', label: 'Release Height', type: "dropdown" },
    //         { value: 'speed', label: 'Speed', type: "dropdown" },
    //         { value: 'bounceLine', label: 'Bounce Line', type: "dropdown" },
    //         { value: 'bounceLength', label: 'Bounce Length', type: "dropdown" },
    //         { value: 'impactPoint', label: 'Impact Point', type: "dropdown" },
    //         { value: 'stumpsPoint', label: 'At Stumps Point', type: "dropdown" },
    //         { value: 'batSwingTracking', label: 'Bat Swing Tracking', type: "dropdown" },
    //         { value: 'batImpactTracking', label: 'Bat Impact Tracking', type: "dropdown" },
    //     ],
    // },
]
</script>

<style>
.p-accordion .p-accordion-header .p-accordion-header-link {
    padding: .3rem;
    margin-left: 1rem;
    ;
    flex-direction: row-reverse !important;
    background: white;
}

.pi {
    color: gray;
    font-size: small;
}

.p-accordion-content {
    padding: 4px;
}


input[type=text] {
    border: 2px solid #ececec;
    border-radius: 4px;
}

.p-autocomplete:not(.p-disabled).p-focus .p-autocomplete-multiple-container {
    box-shadow: none;
}


.p-checkbox-box {
    border: 2px solid #ececec;
    border-radius: 4px;
}
</style>
